import styled from 'styled-components';
const Container = styled.div ``;
const Wrapper = styled.div ``;
export const TrustpilotEmbedStyles = {
    Container,
    Wrapper,
};
